import { ReactNode } from "react";
import styles from "./AnalyticsPageLayout.module.scss";

type Props = {
	title: string;
	/** The filter row, rendered opposite the title. */
	filters?: ReactNode;
	children?: ReactNode;
};

/** Title and filters over a column of widgets — the shape of every analytics page. */
const AnalyticsPageLayout = ({ title, filters, children }: Readonly<Props>) => (
	<div className={styles.container}>
		<div className={styles.header}>
			<h1 className={styles.title}>{title}</h1>
			{filters}
		</div>
		{children}
	</div>
);

export default AnalyticsPageLayout;
